import React, { type ReactNode } from 'react';

import { AnimatePresence } from 'framer-motion';

import { Tick } from './components';

import { StyledBar } from './styles';

export interface BarProps {
    children: ReactNode;
}

// TODO: Investigate using the <meter /> element.
// Example: <meter low={10} high={80} max={100} value={62}>Label</meter>

export function Bar({ children }: BarProps) {
    // TODO: It would be ideal to stagger children both on page load
    // and when multiple items are made `active` at the same time.
    // This is currently difficult, because each <li /> is independently
    // assigned `active`. I believe we would need to capture
    // "number of new active items" each time there was a change to the
    // `children/items` and manually pass a `custom` value so we can
    // calculate a `delay` within each item's animation.
    return (
        <StyledBar>
            <AnimatePresence initial={false}>{children}</AnimatePresence>
        </StyledBar>
    );
}

Bar.Tick = Tick;
